import { __extends } from "tslib";
import { release, notImplemented } from '@awayfl/swf-loader';
import { Event } from './Event';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: TextEvent
var TextEvent = /** @class */ (function (_super) {
    __extends(TextEvent, _super);
    function TextEvent(type, bubbles, cancelable, text) {
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._text = text;
        return _this;
    }
    Object.defineProperty(TextEvent.prototype, "text", {
        get: function () {
            return this._text;
        },
        set: function (value) {
            this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    TextEvent.prototype.clone = function () {
        var textEvent = new TextEvent(this.type, this.bubbles, this.cancelable, this.text);
        //this.copyNativeData(textEvent);
        return textEvent;
    };
    TextEvent.prototype.toString = function () {
        return this.formatToString('TextEvent', 'type', 'bubbles', 'cancelable', 'text');
    };
    TextEvent.prototype.copyNativeData = function (event) {
        release || notImplemented('public flash.events.TextEvent::copyNativeData');
    };
    TextEvent.classInitializer = null;
    TextEvent.classSymbols = null;
    TextEvent.instanceSymbols = null;
    TextEvent.LINK = 'link';
    TextEvent.TEXT_INPUT = 'textInput';
    return TextEvent;
}(Event));
export { TextEvent };
